import styled from 'styled-components'

import { Switch as AntSwitch } from 'antd'

export const Breadcrumbs = styled.div`
  background-color: white;
  padding: 12px 0 0 12px;
`

export const Content = styled.div`
  margin: 8px 16px 24px 16px;
`

export const Switch = styled(AntSwitch)`
  width: 5rem;
`
